import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeaderProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="min-w-0">
        <div className="flex items-center gap-2.5">
          <span className="h-5 w-1 rounded-full bg-accent-500"></span>
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        </div>
        {subtitle && <p className="mt-2 text-sm text-foreground-600">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 cursor-pointer items-center gap-1 rounded-full border border-background-200 px-3.5 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-line text-sm"></i>
        </Link>
      )}
    </div>
  );
}